import {
  APP_INSTALLS,
  CONVERSIONS,
  ENGAGEMENT,
  LEAD_GENERATION,
  TRAFFIC,
  VIDEO_VIEWS
} from '../../../../../constants/campaigns'

export const getShowBudgetStep = campaignObjective => {
  return (
    campaignObjective === CONVERSIONS ||
    campaignObjective === VIDEO_VIEWS ||
    campaignObjective === TRAFFIC ||
    campaignObjective === ENGAGEMENT ||
    campaignObjective === APP_INSTALLS ||
    campaignObjective === LEAD_GENERATION
  )
}
